import type {
  ReactElement,
} from 'react';

import styled from 'styled-components';

import { NavLink } from 'react-router-dom';

import type {
  HeaderMenuLinkParams,
} from '../types';

export const StyledNavLink = styled(NavLink)(({
  theme: {
    colors,
    fonts,
    layout,
    tabs,
  },
}) => ({
  ...fonts.DEFAULT,
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  height: layout.HEADER_HEIGHT,
  whiteSpace: 'nowrap',
  color: colors[tabs.INACTIVE_COLOR],
  textDecoration: 'none',

  '::after': {
    content: '""',
    display: 'block',
    position: 'absolute',
    height: tabs.ACTIVE_BORDER_WIDTH,
    left: 0,
    bottom: 0,
    width: '100%',
    backgroundColor: 'transparent',
  },

  ':hover': {
    color: colors[tabs.INACTIVE_COLOR_HOVER],

    '::after': {
      backgroundColor: colors[tabs.ACTIVE_BORDER_COLOR],
    },
  },

  ':active': {
    color: colors[tabs.INACTIVE_COLOR_PRESSED],

    '::after': {
      backgroundColor: tabs.ACTIVE_BORDER_COLOR,
    },
  },

  '&.n3__active': {
    color: colors[tabs.ACTIVE_COLOR],

    '::after': {
      backgroundColor: colors[tabs.ACTIVE_BORDER_COLOR],
    },

    ':hover': {
      color: colors[tabs.ACTIVE_COLOR],
    },

    ':active': {
      color: colors[tabs.ACTIVE_COLOR],
    },
  },
}));

export function HeaderMenuLink({
  url,
  text,
  ...rest
}: HeaderMenuLinkParams): ReactElement {
  return (
    <StyledNavLink
      activeClassName="n3__active"
      to={url}
      {...rest}
    >
      { text }
    </StyledNavLink>
  );
}
